import { render, staticRenderFns } from "./destroy_confirmation.vue?vue&type=template&id=fee66506&lang=pug&"
import script from "./destroy_confirmation.vue?vue&type=script&lang=coffee&"
export * from "./destroy_confirmation.vue?vue&type=script&lang=coffee&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* custom blocks */
import block0 from "./destroy_confirmation.vue?vue&type=custom&index=0&blockType=i18n"
if (typeof block0 === 'function') block0(component)

export default component.exports